import React, { useState, useEffect } from "react";
import TaskList from "./TaskList";
import Rewards from "./Rewards";
import MusicPlayer from "./MusicPlayer";
import LuckBar from "./LuckBar";
import WeeklyOutcome from "./WeeklyOutcome";
import WaifuReactions from "./WaifuReactions";
import Timesheet from "./Timesheet";
import IkarosWishGate from "./IkarosWishGate"; // 💫 NEW IMPORT HERE
import {
  getPoints,
  savePoints,
  saveTasks,
  getLuckFromServer,
  saveLuckToServer
} from "./localStorageUtils";
import motivationalQuotes from "./motivationalQuotes";

const RandomMotivationalQuote = () => {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    const randomQuote =
      motivationalQuotes[Math.floor(Math.random() * motivationalQuotes.length)];
    setQuote(randomQuote);
  }, []);

  return (
    <div className="mt-6 mb-8 p-4 rounded-lg bg-gradient-to-r from-blue-500 via-blue-400 to-cyan-400 shadow-lg mx-4 md:mx-0">
      <p className="text-xl md:text-2xl font-semibold text-center text-white italic">
        {quote}
      </p>
    </div>
  );
};

const Dashboard = () => {
  const [points, setPoints] = useState(0);
  const [tasks, setTasks] = useState([]);
  const [luck, setLuck] = useState(0);
  const [weeklyOutcome, setWeeklyOutcome] = useState({ mode: "neutral", streak: 0 });
  const [mode, setMode] = useState("stabilization");
  const [strobeActive, setStrobeActive] = useState(false);

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const storedPoints = await getPoints();
        setPoints(storedPoints);
        const storedLuck = await getLuckFromServer();
        setLuck(storedLuck);
      } catch (error) {
        console.error("Failed to fetch initial data:", error);
      }
    };
    fetchInitData();
  }, []);

  useEffect(() => {
    const total = tasks.length;
    const completed = tasks.filter((t) => t.completed).length;
    const newLuck = total > 0 ? Math.round((completed / total) * 100) : 0;
    setLuck(newLuck);
    saveLuckToServer(newLuck).catch((err) =>
      console.error("Failed to save luck:", err)
    );

    if (total > 0) {
      const ratio = completed / total;
      setMode(ratio >= 0.5 ? "momentum" : "stabilization");
    } else {
      setMode("stabilization");
    }
  }, [tasks]);

  const completeReset = async () => {
    setPoints(0);
    setTasks([]);
    setLuck(0);
    setWeeklyOutcome({ mode: "neutral", streak: 0 });
    try {
      await savePoints(0);
      await saveTasks([]);
    } catch (err) {
      console.error("Failed to reset tasks or points:", err);
    }
  };

  const updatePoints = async (earnedPoints) => {
    const newPoints = points + earnedPoints;
    setPoints(newPoints);
    try {
      await savePoints(newPoints);
    } catch (error) {
      console.error("Failed to update points:", error);
    }
  };

  const spendPoints = async (cost) => {
    const newPoints = points - cost;
    setPoints(newPoints);
    try {
      await savePoints(newPoints);
    } catch (error) {
      console.error("Failed to spend points:", error);
    }
  };

  const activateStrobe = () => {
    setStrobeActive(true);
    setTimeout(() => {
      setStrobeActive(false);
    }, 10000);
  };

  const handleOutcomeChange = (newMode, streak) => {
    setWeeklyOutcome({ mode: newMode, streak });
  };

  return (
    <div className="p-4 md:p-8 min-h-screen transition-all text-white bg-gray-900">
      <RandomMotivationalQuote />
      <LuckBar luck={luck} mode={mode} />
      <WeeklyOutcome
        tasks={tasks}
        mode={mode}
        triggerStrobe={activateStrobe}
        onOutcomeChange={handleOutcomeChange}
      />
      <WaifuReactions tasks={tasks} mode={mode} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
        <TaskList
          tasks={tasks}
          setTasks={setTasks}
          updatePoints={updatePoints}
          completeReset={completeReset}
        />
        <MusicPlayer />
      </div>
      {/* Timesheet appears here */}
      <div className="mt-8">
        <Timesheet />
      </div>

      {/* 💖 Ikaros Wish Gate now appears below Timesheet */}
      <div className="mt-8">
        <IkarosWishGate />
      </div>

      {/* Rewards at the bottom */}
      <div className="mt-8 md:mt-12">
        <Rewards points={points} spendPoints={spendPoints} />
      </div>
    </div>
  );
};

export default Dashboard;
